import { AddressStore } from './addressStore/AddressStore'
import { DiscountStore } from './discountStore/DiscountStore'
import { PhotoBankStore } from './photoBankStore/PhotoBankStore'
import { PhotoBankUploadService } from './photoBankStore/PhotoBankUploadService'
import { PhotoBooksStore } from './photoBooksStore/PhotoBooksStore'
import { TilesStore } from './tilesStore/TilesStore'

/**
 * RootStore manages store initialization with explicit dependency injection.
 * New stores will be added here as they are implemented.
 */
export class RootStore {
  addressStore: AddressStore

  discountStore: DiscountStore

  photoBankStore: PhotoBankStore

  photoBooksStore: PhotoBooksStore

  tilesStore: TilesStore

  constructor() {
    this.addressStore = new AddressStore()
    this.discountStore = new DiscountStore()
    this.photoBankStore = new PhotoBankStore(new PhotoBankUploadService())
    this.photoBooksStore = new PhotoBooksStore(this.photoBankStore)
    this.tilesStore = new TilesStore(this.photoBankStore)
  }
}
